import { CategoryId } from '~/models/category/types'
import { ViewType } from '~/models/shared/types'
import { SearchConfig } from '~/models/search/config'

export const plotMapSearchConfig: SearchConfig = Object.freeze({
  settings: {
    viewType: {
      defaultViewTypeMobile: ViewType.LIST,
      defaultViewTypeDesktop: ViewType.GALLERY
    },
    searchName: 'plot',
    searchbar: {
      autocompleteEndpoint: '/api/classifieds/query/',
      usesNuxtLinks: true
    },
    displayAds: true
  },
  // showBreadcrumbs: true
  rootParams: {
    category: [CategoryId.PLOT]
  }
})

export const plotSearchConfig: SearchConfig = Object.freeze({
  settings: {
    viewType: {
      defaultViewTypeMobile: ViewType.LIST,
      defaultViewTypeDesktop: ViewType.GALLERY
    },
    searchName: 'plot',
    searchbar: {
      autocompleteEndpoint: '/api/classifieds/query/',
      usesNuxtLinks: true
    },
    displayAds: true
  },
  rootParams: {
    category: [CategoryId.PLOT]
  }
})
